import { useCallback, useState } from 'react';

export const useParticipantModerationPopup = () => {
    const [showModerationPopupId, setShowModerationPopupId] = useState<string | null>(null);

    const closeModerationPopup = useCallback(() => {
        setShowModerationPopupId(null);
    }, []);

    const openModerationPopup = useCallback(
        (id: string) => {
            // Клик по той же кнопке, где открыт попап, должен закрыть его
            if (id === showModerationPopupId) {
                return closeModerationPopup();
            }

            setShowModerationPopupId(id);
        },
        [closeModerationPopup, showModerationPopupId]
    );

    return {
        showModerationPopupId,
        openModerationPopup,
        closeModerationPopup,
    };
};
